import { useParams } from "react-router-dom";
import "../Profiles/profileStyles.css"
import dp from "../../images/ls1.png";
import cp from "../../images/cv.jpg";
import { MediaRenderer } from "@thirdweb-dev/react";
import { Link } from "react-router-dom";
import "../Profiles/nftStyles.css";
import {TailSpin} from 'react-loader-spinner';
import { useState, useEffect } from "react";
import { lensClient} from "../../client/LensClient";
import { LimitType } from "@lens-protocol/client";

export default function MyProfileNfts(){
    const {myNfts} = useParams();

    const [data, setData] = useState();
    const [nfts,setNfts] = useState(); 

    useEffect(()=>{
      async function fetchProfiles(){
        const profileByHandle = await lensClient.profile.fetch({
          forProfileId: myNfts,
        })
        setData(profileByHandle);
        
        const result = await lensClient.nfts.fetch({
          where: {
            chainIds: [80001],
            forProfileId:myNfts,
            //forAddress: profileByHandle.ownedBy.address,
          },
          limit: LimitType.TwentyFive,
        });
        setNfts(result);
        console.log(result);
      }
      fetchProfiles();
  },[data,nfts])

    return(
      <div className="profilePage">      
          <div className="">
            {data==null?<div className="spinner">
                <TailSpin height={150}></TailSpin>
          </div>:
            <>
          {data.metadata?.coverPicture?.optimized?.uri==null?
            <img src = {cp} className="banner"
                alt = {data.handle?.localname}/>
            :
           <img src = {data.metadata.coverPicture.optimized.uri} className="banner"
           alt = {data.handle?.localname}/>
          }
      <div className="profile">
        <div className="profileLeft">
        {data.metadata?.picture?.optimized?.uri==null?
            <MediaRenderer src = {dp} alt = {data.handle?.localname} className="profileImg"/>
            :
            <MediaRenderer src = {data.metadata?.picture?.optimized?.uri} className="profileImg"
                alt = {data.handle?.localname}/>
        }
         
        <div className="info">
            <div className="pname">{data.metadata?.displayName || "Anonymous User"}</div>
            <div className="phandle">{data.handle?.localName|| ""}</div>
            <div className="pbio">{data.metadata?.bio || "anonymous"}</div>
            <div className = "attr">
            {data.metadata?.attributes?.map((itm)=>(
              <>
              <div className = "follow">
                <div>{itm.key}:</div>
                <div>{itm.value}</div>
              </div>
              </> 
            ))}
          </div>
            <div className="follow">
              <div>Followers:</div>
              <div>{data.stats.followers}</div>
            </div>
            <div className="follow">
              <div>Following:</div>
              <div>{data.stats.following}</div>
            </div>
            <div className = "editBtn">
            <button> <Link to= {`/edit/${myNfts}`}>Edit Your Profile</Link></button>
        </div>
          </div>
        </div>
        <div className="profileRight">
          <div className="postsType">
            <div className="tab">
            <Link to = {`/myprofile/${myNfts}`}>My Posts</Link>
          <Link to={`/myprofile/nfts/${myNfts}`} > My Nfts</Link>
          <Link to = {`/myProfile/mirrors/${myNfts}`}>My Mirrors</Link>
          <Link to = {`/post/${myNfts}`}>New post</Link>
          <Link to = "/conference">Meeting Room</Link>
            </div>
          </div>
          <div className="content">
            {nfts==null?
            <div className="spinner">
                <TailSpin height={150}></TailSpin>
          </div>:<>
          {nfts?.items?.length==0?<div>
            <p>No nfts yet</p>
          </div>:<></>}
          </>
          
          }
           {/*{po_data.nfts.items.length>0?
          <div className="ycards">
            {po_data.nfts.items.map((nft) =>(
            <>
            <div className="cont">
            {
              (() => {   
                if(nft?.originalContent?.uri.startsWith('https://ipfs.io'))
                  return <div className="bgImage">
                          <MediaRenderer className="feedImage"
                            src={
                                `http://lens.infura-ipfs.io/ipfs/${nft.originalContent.uri.substring(21,
                                  nft.originalContent.uri.length)}`
                                }
                            alt={nft.name}
                          />
                          </div>
                else if(nft?.originalContent?.uri.startsWith('ipfs://'))
                  return <div className="bgImage">
                          <img className="feedImage"
                          src={
                          `http://lens.infura-ipfs.io/ipfs/${nft.originalContent.uri.substring(7,
                          nft.originalContent.uri.length)}`
                        }
                        alt={nft.name}
                        />
                      </div>
                else
                  return <div className="bgImage">
                          <img className="coverImg" src={nft?.originalContent?.uri} alt={nft.name}/>
                          </div>
        })()
          }
          <div className="detail">
            <div className="title-div">
            <p>#{nft.tokenId } { nft.name.substring(0,30)}..</p>
            </div>
            <div  className="middle">
              {nft.description?
                <p> {nft.description?.substring(0,90)}..</p>
              :<></>}
            </div>
              <div className="bottom">
              <div className="left">
                <div className="price-text">
                  <p>ErcType</p>
                  <p>{nft.ercType}</p>
                </div>
              </div>
              <div className="right">
                <div className="remaining-text">
                  <p>Symbol</p>
                  <p>{nft.symbol}</p>
                </div>
              </div>
            </div>
            </div>
            </div>
            </>
            ))}
          </div>
            :
          <div  className="notfound"><h2>{data.handle?.localname} has no Nft's yet.</h2></div>
          }*/}
        </div> 
        </div>
    </div></>}
    </div>
    </div>
    );
}